<template>
  <footer style="padding: 40px 0;">
  </footer>
</template>

<script>
export default {
  name: 'FooterPrismic'
}
</script>

<style scoped>
.footer {
  padding: 40px 0;
  max-width: 700px;
  margin: 0 auto;
  text-align: center;
  border-top: 1px solid #DADADA;
  border-top: 1px solid #1b1b1b;
}
.logo {
  width: 100px;
}
</style>
